let mobileNavOpen = $('#site-navigation-open'),
    mobileNavClose = $('#site-navigation-close'),
    mobileMenu = $('#primary-navigation');

mobileNavOpen.on('click', function(e) {
    mobileMenu.fadeIn();
});

mobileNavClose.on('click', function(e) {
    mobileMenu.fadeOut();
});

if($(window).outerWidth() <= 1200) {
    if($('.site-banner').length) {
        mobileMenu.css('height', 'calc(100vh - ' + $('.site-banner').outerHeight() + 'px)');
        mobileMenu.css('top', $('.site-banner').outerHeight() + 'px');
    }
}


let subMenuToggles = $('.menu-item-has-children > a');

subMenuToggles.on('click', function(e) {
    e.preventDefault();

    let subMenu = $(this).next('.sub-menu');

    $(this).parent().toggleClass('active');
    subMenu.slideToggle(200);
});
